@if (
  {
    question: question$ | async,
    useMaxHeightOnRow: useMaxHeightOnRow$ | async,
    childQuestions: childQuestions$ | async,
  };
  as data
) {
  <div [class.row-max-height]="data.useMaxHeightOnRow" class="row">
    <div
      class="col"
      [class.follow-up]="followUpLevel > 0 && state === QuestionState.Visible"
      [class.question]="state === QuestionState.Visible"
      [ngClass]="[followUpLevel > 0 ? 'fup-' + followUpLevel : '']"
    >
      @if (state === QuestionState.Visible) {
        <lib-question-container
          [animate.enter]="'state-fade-in'"
          [formGroup]="questionFormGroup"
          [labelPrefix]="labelPrefix"
          [questionsInRow]="questionsInRow"
          [repeaterGroupId]="repeaterGroupId"
        >
        </lib-question-container>
      }
    </div>
  </div>
  @if (data.question && data.question.structure.followUpQuestionsOrder) {
    <div class="follow-up-container">
      @for (
        childRow of data.question.structure.followUpQuestionsOrder;
        track trackByFn(i, childRow);
        let i = $index
      ) {
        <div class="row">
          @for (
            childQuestion of childRow;
            track trackByFn($index, childQuestion)
          ) {
            <div class="col">
              @if (state === QuestionState.Visible) {
                <lib-question
                  [animate.enter]="'state-fade-in'"
                  [questionFormGroup]="
                    data.childQuestions[childQuestion].childQuestionFormGroup
                  "
                  [showQuestion]="
                    showAllFollowUps ||
                    data.childQuestions[childQuestion].showChildQuestion
                  "
                  [followUpLevel]="followUpLevel + 1"
                  [labelPrefix]="labelPrefix"
                  [showAllFollowUps]="showAllFollowUps"
                  [questionsInRow]="childRow.length"
                  [repeaterGroupId]="repeaterGroupId"
                ></lib-question>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}
